import {
  Autocomplete,
  Box,
  Card,
  CardContent,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";

export const CustomerSelector = ({
  customers,
  selected_customer,
  on_customer_change,
  on_customer_input_change,
  search_loading,
  message = "Wählen Sie den Kunden aus, für den Sie Vorlagen herunterladen, Kataloge abrufen oder Importe durchführen möchten.",
}) => {
  return (
    <Card sx={{ mb: 3, mt: 4, boxShadow: "none", border: "none", padding: 0 }}>
      <CardContent sx={{ padding: 0 }}>
        <Typography variant="h6" gutterBottom>
          Kunde auswählen
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {message}
        </Typography>
        <Autocomplete
          options={customers}
          getOptionLabel={(option) => option.display || ""}
          value={selected_customer}
          onChange={on_customer_change}
          onInputChange={on_customer_input_change}
          loading={search_loading}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Kunde auswählen"
              placeholder="Kundenname oder ID eingeben..."
              required
              slotProps={{
                input: {
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {search_loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                },
              }}
            />
          )}
          renderOption={(props, option) => (
            <Box component="li" {...props}>
              <Box>
                <Typography variant="body2">{option.label}</Typography>
                {option.location && (
                  <Typography variant="caption" color="text.secondary">
                    {option.location} • ID: {option.id_ov}
                  </Typography>
                )}
              </Box>
            </Box>
          )}
          noOptionsText="Keine Kunden gefunden. Geben Sie mindestens 2 Zeichen ein."
        />
      </CardContent>
    </Card>
  );
};
